module.exports = __webpack_public_path__ + "media/boxes/exploding-box--yellow-a98caf35.svg";